import { PromptSuggestions } from './PromptSuggestions';
const meta = {
    title: 'Features/AIChatWidget/PromptSuggestions',
    component: PromptSuggestions
};
export default meta;
export const Default = {
    args: {
        onSelectPrompt: (prompt) => {
            console.log('Selected prompt:', prompt);
        }
    }
};
